var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "height": "auto",
      "name": "favoriteModal",
      "width": "90%",
      "clickToClose": false
    },
    on: {
      "beforeOpen": _vm.beforeOpenModal
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools new-modal-wrapper-no-buttons",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "headerImg": true
    },
    on: {
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "new-modal-title",
      "elementType": "h2",
      "text": _vm.translations.favoritesTitle
    }
  }), _c('CustomContainer', {
    staticClass: "content"
  }, [_vm.enableFavoritesModal ? _c('CustomContainer', [_c('CustomContainer', {
    staticClass: "row"
  }, [_c('CustomText', {
    attrs: {
      "customClass": "new-modal-description",
      "text": _vm.textMessage
    }
  })], 1), _c('CustomContainer', {
    staticClass: "row"
  }, [_c('CustomImage', {
    attrs: {
      "customClass": "modals-favorites-img",
      "src": _vm.imageUrl,
      "alt": _vm.pdm.product_name
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })], 1), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  })], 1) : _c('CustomText', {
    attrs: {
      "elementType": "h5",
      "text": _vm.textMessage
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }